import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var PictureIcon64Regular = forwardRefAndName('PictureIcon64Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 64
    }, props), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.5 24C19.5 20.6863 22.1863 18 25.5 18C28.8137 18 31.5 20.6863 31.5 24C31.5 27.3137 28.8137 30 25.5 30C22.1863 30 19.5 27.3137 19.5 24ZM25.5 21C23.8431 21 22.5 22.3431 22.5 24C22.5 25.6569 23.8431 27 25.5 27C27.1569 27 28.5 25.6569 28.5 24C28.5 22.3431 27.1569 21 25.5 21Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M34.5251 35.0962C35.892 33.7294 38.108 33.7294 39.4749 35.0962L43.9393 39.5607C44.5251 40.1464 45.4749 40.1464 46.0607 39.5607C46.6464 38.9749 46.6464 38.0251 46.0607 37.4393L41.5962 32.9749C39.0578 30.4365 34.9422 30.4365 32.4038 32.9749L20.9393 44.4394C20.3536 45.0252 20.3536 45.975 20.9393 46.5608C21.5251 47.1465 22.4749 47.1465 23.0607 46.5607L34.5251 35.0962Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 16.5C11 10.701 15.701 6 21.5 6H35.9522C37.9413 6 39.8489 6.79017 41.2555 8.1967L50.8033 17.7445C52.2098 19.1511 53 21.0587 53 23.0478V47.5C53 53.299 48.299 58 42.5 58H21.5C15.701 58 11 53.299 11 47.5V16.5ZM21.5 9C17.3579 9 14 12.3579 14 16.5V47.5C14 51.6421 17.3579 55 21.5 55H42.5C46.6421 55 50 51.6421 50 47.5V23.0478C50 21.8544 49.5259 20.7098 48.682 19.8659L39.1341 10.318C38.2902 9.4741 37.1456 9 35.9522 9H21.5Z"
    }))
  );
});